<template>
  <v-app-bar class="app-bar" dark>
    <v-spacer></v-spacer>
    <div class="app-bar-logo__container">
      <img
        class="app-bar-logo"
        src="@/assets/kikusui_app_bar_logo.png"
        alt="Logo"
      />
    </div>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    isFixed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style scoped>
.app-bar {
  background-color: #005c9e !important;
}
.app-bar-logo__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.app-bar-logo {
  height: 100%;
  padding: 4px 0px;
  transition: height 0.3s ease;
}

@media screen and (max-width: 600px) {
  .app-bar-logo {
    object-fit: contain;
  }
}
</style>
